import {
    FETCH_ONBOARDING_SPONSOR_CONFIG_REQUEST,
    FETCH_ONBOARDING_SPONSOR_CONFIG_SUCCESS,
    FETCH_ONBOARDING_SPONSOR_CONFIG_FAILURE,
    UPDATE_ONBOARDING_SPONSOR_CONFIG_REQUEST,
    UPDATE_ONBOARDING_SPONSOR_CONFIG_SUCCESS,
    UPDATE_ONBOARDING_SPONSOR_CONFIG_FAILURE,
} from '../actions/onboardingSponsorConfigActions';

const initialState = {
    config: null,
    loading: false,
    error: null,
};

const onboardingSponsorConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ONBOARDING_SPONSOR_CONFIG_REQUEST:
        case UPDATE_ONBOARDING_SPONSOR_CONFIG_REQUEST:
            return { ...state, loading: true, error: null };
            
        case FETCH_ONBOARDING_SPONSOR_CONFIG_SUCCESS:
        case UPDATE_ONBOARDING_SPONSOR_CONFIG_SUCCESS:
            return { ...state, loading: false, config: action.payload, error: null };
            
        case FETCH_ONBOARDING_SPONSOR_CONFIG_FAILURE:
        case UPDATE_ONBOARDING_SPONSOR_CONFIG_FAILURE:
            return { ...state, loading: false, error: action.payload };
            
        default:
            return state;
    }
};

export default onboardingSponsorConfigReducer;
